import React from 'react';
import { Helmet } from 'react-helmet-async';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'modules';
import MenteeMentoringAbout from 'components/mentoring/mentee/MenteeMentoringAbout';
import MentorMentoringAbout from 'components/mentoring/mentor/MentorMentoringAbout';
import { CWindowWidth } from 'constants/base.const';
import { CMentoringFieldType } from 'constants/mentoring.const';
import { EUserType } from 'enums/base.enum';
import { Tabs, Col, Row, Typography } from 'antd';
import styled from 'styled-components';
import { PrimaryColor, device } from 'GlobalStyles';
import titleImage from 'assets/images/banners/2.webp';
import applyImage from 'assets/images/banners/6.webp';
import 'animate.css/animate.min.css';

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const MentoringAboutWrapper = styled.div`
  overflow: hidden;

  .title-mentoring {
    width: 100%;
    /* height: 380px; */
    height: 300px;
    background: linear-gradient(0deg, rgba(42, 71, 83, 0.3), rgba(42, 71, 83, 0.3)), url(${titleImage});
    background-size: cover;
    padding: 50px 10px;
    .ant-typography {
      width: 100%;
      color: #ffffff;
      margin: auto;
      display: block;
    }
    span.ant-typography {
      font-size: 16px;
    }
  }
  .demo-picture {
    height: 299px;
    weigth: 100%;
    border: 1px solid balck;
    background-color: #f0f8f6;
  }

  .step-info {
    margin: auto;
    max-width: 420px;
    font-size: 16px;
    .ant-list-item-meta-description {
      color: #14112a;
      text-align: justify;
      font-size: 16px;
    }
    .ant-list-item-meta-avatar {
      margin-right: 8px;
    }
    .step {
      font-weight: bold;
      color: ${PrimaryColor};
    }
  }
  .step-info.step-right {
    margin-right: 0px;
  }
  .step-info.step-left {
    margin-left: 0px;
  }

  .title-mentoring {
    background-color: #2a4753;
    position: relative;
  }

  .title-text {
    position: absolute;
    top: 50%;
    left: 48%;

    @media (max-width: 800px) {
      left: 50%;
    }

    .p-title {
      font-size: 48px;
      color: #ffffff;
      font-weight: bold;
      margin-bottom: 10px;
      min-width: 600px;

      @media (max-width: 800px) {
        font-size: 30px;
      }
    }

    .p-body {
      font-size: 18px;
      color: #ffffff;
      min-width: 600px;
    }
  }

  .apply-mentoring {
    height: 248px;
    border-radius: 8px;
    background-color: #2a4753;
    background-image: url(${applyImage});
    background-repeat: no-repeat;
    background-position-x: 100%;
    margin: 40px 50px 60px 50px;
    @media screen and ${device.md} {
      margin: 20px 0px;
    }
    .apply-mentoring-content {
      max-width: ${CWindowWidth - 300}px;
      margin: auto;
      padding: 50px 10px;
    }
  }

  .ant-btn-primary {
    background-color: red;
  }
`;
const MentoringAbout = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);

  return (
    <MentoringAboutWrapper>
      <Helmet>
        <title>
          {currentUser?.primary_field && CMentoringFieldType[currentUser?.primary_field]} - 멘토링 방식 소개
        </title>
      </Helmet>
      <div className='title-mentoring'>
        <Row align='middle' style={{ height: '100%' }}>
          <Col xs={{ offset: 0 }} sm={{ offset: 0 }} md={{ offset: 2 }} lg={{ offset: 2 }} xl={{ offset: 2 }}>
            <Title>멘토링 진행 방식 소개</Title>
            <Text style={{ marginTop: '10px' }}>Career Step의 멘토링 진행 과정을 한 눈에 확인하세요.</Text>
          </Col>
        </Row>
      </div>
      {currentUser?.user_type === EUserType.Mentee ? <MenteeMentoringAbout /> : <MentorMentoringAbout />}
    </MentoringAboutWrapper>
  );
};

export default MentoringAbout;
